<template>
  <!--搜索栏-->
  <common-query :query="query" @query="onClickQuery">
    <el-form-item label="档案号">
      <el-input v-model="query.merId" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户名称">
      <el-input v-model="query.merName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="法人姓名">
      <el-input v-model="query.corpName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="城市服务商">
      <common-select v-model="query.serviceId" :list="serviceList" />
    </el-form-item>
    <el-form-item label="城市">
      <common-select v-model="query.area" :list="areaList" />
    </el-form-item>
    <el-form-item label="联系电话">
      <el-input v-model="query.corpPhone" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="收单机构">
      <common-select v-model="query.companyId" :list="companyList" />
    </el-form-item>
    <el-form-item label="渠道">
      <common-select v-model="query.bankId" :list="bankList" />
    </el-form-item>
    <el-form-item label="激活状态">
      <common-select v-model="query.activeType" :list="activeTypeList" />
    </el-form-item>
    <el-form-item label="进件时间" class="auto-width">
      <date-picker v-model="query.createTimeStart" />
      <span class="middle-text">至</span>
      <date-picker v-model="query.createTimeEnd" />
    </el-form-item>
  </common-query>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default() {
        return {}
      },
      comment: '查询数据条件'
    },

    serviceList: Array, //城市服务商
    areaList: Array, //城市
    companyList: Array, //收单机构
    bankList: Array, //渠道
    activeTypeList: Array //激活状态
  },

  data() {
    return {}
  },

  methods: {
    onClickQuery() {
      this.$emit('query', this.query)
    }
  }
}
</script>
